import { render, staticRenderFns } from "./FotorDialogMsg.vue?vue&type=template&id=412c8d98&scoped=true"
import script from "./FotorDialogMsg.vue?vue&type=script&lang=js"
export * from "./FotorDialogMsg.vue?vue&type=script&lang=js"
import style0 from "./FotorDialogMsg.vue?vue&type=style&index=0&id=412c8d98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412c8d98",
  null
  
)

export default component.exports